import {z} from 'zod'

export const tokenInfoSchema = z
  .object({
    token: z.string(),
    type: z.string(),
    created_at: z.number(),
    expires_in: z.number(),
    user_uuid: z.string(),
    organisation_uuid: z.string(),
  })
  .partial()

export type TokenInfo = z.infer<typeof tokenInfoSchema>
